import Vue from 'vue';
import store from '../store/index.js';
import LastClickedProducts from '../components/shared/last-clicked-products-component.vue';

DM.Module.LastClicked = ((DM) => {
    const SELECTOR = '.js-last-clicked-products';
    const ELEMENT = document.querySelector(SELECTOR);

    class LastClicked {
        constructor(element) {
            const forcePreviewParam = element.dataset.forcePreview || '';
            this.createComponent(element, forcePreviewParam);
        }

        createComponent(element, forcePreviewParam) {
            return new Vue({
                name: 'dm-last-clicked-products',
                el: element,
                store,
                components: {
                    'dm-last-clicked-products': LastClickedProducts,
                },
                template: '<dm-last-clicked-products :forcePreviewParam="forcePreviewParam" place="main_page" />',
                data: {
                    forcePreviewParam: forcePreviewParam,
                },
            });
        }
    }
    if (ELEMENT) {
        new LastClicked(ELEMENT);
    }
})(window.DM);
